module.exports = __webpack_public_path__ + "img/cooperative2_logo0.e507944d.jpg";